// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_Py-","cls2":"JJHomePageSearch-cls2_92s JJHomePageSearch-cls1_Py-"};